import React from "react";
import Select from "react-select";

const selectStyles = {
  container: provided => ({
    ...provided,
    width: "100%"
  }),
  control: provided => ({
    ...provided,
    border: "none",
    boxShadow: "var(--shadow)",
    borderRadius: 0
  }),
  placeholder: provided => ({
    ...provided,
    color: "var(--medium-gray)",
    opacity: 0.5
  }),
  menu: provided => ({
    ...provided,
    borderRadius: 0
  }),
  option: (provided, state) => {
    return {
      ...provided,
      backgroundColor: state.isSelected ? "var(--dark-primary)" : state.isFocused ? "#f7f6f6" : "#fff",
      ...(state.isSelected ? { fontWeight: "700" } : {}),
      ":active": {
        ...provided[":active"],
        backgroundColor: state.isSelected ? "var(--dark-primary)" : "var(--dark-primary-transparent)"
      }
    };
  }
};

const MultiSelect = props => {
  const options = (props?.options || []).map(o => ({ label: o, value: o }));
  const value = (props?.value || []).map(v => ({ label: v, value: v }));
  const onChange = selections => {
    const selectionValues = (selections || []).map(s => s.value);
    props?.onChange && props.onChange(selectionValues);
  };

  return <Select styles={selectStyles} {...props} options={options} value={value} onChange={onChange} isMulti={true} />;
};

export default MultiSelect;
